import { combineReducers } from 'redux'
import advisors from './advisors/reducer'
import advisor from './advisor/reducer'
import taxes from './taxes/reducer'
import users from './users/reducer'
import settings from './settings/reducer'

export const admin = combineReducers({
  advisors,
  advisor,
  taxes,
  users,
  settings,
})
